import './EditButton.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function EditButton({ onClick }) {
    const [isHovered, setIsHovered] = useState(false);
    const { t: tCommon } = useTranslation('common');

    return (
        <div 
            className='edit-button'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick} // Chama a função de clique recebida via props
        >
            <img src={isHovered ? './imagens/white-pencil.svg' : './imagens/pencil.svg'} alt={tCommon('edit')} />
            {tCommon('edit')}
        </div>
    );
}

export default EditButton;
